import { ElementRef, QueryList } from '@angular/core';

export class TableUtils {

  public static toggleExpandableRow(
    rows: QueryList<ElementRef<HTMLTableRowElement>>,
    activeRow: HTMLTableRowElement,
    forceOpen = false,
  ): void {
    rows.forEach(x => {
      const el = x.nativeElement;
      const nextEl = el.nextElementSibling as HTMLElement | null;

      if (!nextEl?.classList.contains('subrow')) {
        return;
      }

      if (activeRow === el) {
        forceOpen ? nextEl.classList.remove('d-none') : nextEl.classList.toggle('d-none');
      } else {
        nextEl.classList.add('d-none');
      }

      el.classList.toggle('expanded', !nextEl.classList.contains('d-none'));
    });
  }
}
